const SPEC_ROWS = [
  { key: 'power', label: 'Power', suffix: ' W' },
  { key: 'speed', label: 'Top speed', suffix: ' mph' },
  { key: 'range', label: 'Range', suffix: ' mi' },
  { key: 'battery', label: 'Battery' },
  { key: 'weight', label: 'Weight', suffix: ' kg' },
];

class SpecComparator extends HTMLElement {
  connectedCallback() {
    // The parser connects this element before its own children (selects,
    // results grid) have been appended, so wait for the full document.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  init() {
    const dataEl = this.querySelector('[data-comparator-products]');
    this.products = dataEl ? JSON.parse(dataEl.textContent) : [];
    this.selects = Array.from(this.querySelectorAll('[data-comparator-select]'));
    this.startBtn = this.querySelector('[data-comparator-start]');
    this.hint = this.querySelector('[data-comparator-hint]');
    this.resultsWrap = this.querySelector('[data-comparator-results]');
    this.grid = this.querySelector('[data-comparator-grid]');

    if (this.startBtn) {
      this.startBtn.addEventListener('click', this.render.bind(this));
    }
  }

  getSelectedProducts() {
    return this.selects
      .map((select) => select.value)
      .filter((id) => id !== '')
      .map((id) => this.products.find((product) => String(product.id) === id))
      .filter(Boolean);
  }

  formatValue(product, row) {
    const value = product[row.key];
    if (value === null || value === undefined || value === '') {
      return '—';
    }
    return row.suffix ? `${value}${row.suffix}` : value;
  }

  render() {
    const selected = this.getSelectedProducts();

    if (selected.length < this.selects.length) {
      if (this.hint) this.hint.hidden = false;
      this.resultsWrap.hidden = true;
      this.grid.innerHTML = '';
      return;
    }

    if (this.hint) this.hint.hidden = true;
    this.resultsWrap.hidden = false;
    this.grid.style.setProperty('--comparator-cols', selected.length);

    this.grid.innerHTML = selected
      .map((product) => {
        const specRows = SPEC_ROWS.map(
          (row) => `
            <div class="spec-comparator__card-spec">
              <span class="spec-comparator__card-spec-label">${row.label}</span>
              <span class="spec-comparator__card-spec-value">${this.formatValue(product, row)}</span>
            </div>
          `
        ).join('');

        return `
          <div class="spec-comparator__card tech-card">
            <a href="${product.url}" class="spec-comparator__card-image-wrap">
              ${product.image ? `<img src="${product.image}" alt="" loading="lazy">` : ''}
            </a>
            <div class="spec-comparator__card-body">
              <a href="${product.url}" class="spec-comparator__card-title">${product.title}</a>
              <p class="spec-comparator__card-price">${product.price || ''}</p>
              <div class="spec-comparator__card-specs">${specRows}</div>
            </div>
          </div>
        `;
      })
      .join('');
  }
}

if (!customElements.get('spec-comparator')) {
  customElements.define('spec-comparator', SpecComparator);
}
